// extracted by mini-css-extract-plugin
module.exports = {"root":"ScreenHeaderDivider_root__3leZ_"};